import * as React from 'react';
import {classNames} from '@shopify/react-utilities/styles';
import {NOOP} from 'components/UIKit/utilities';
import {Icon, Flex, Text} from 'components/UIKit';
import {NavItemData} from '../../types';
import styles from './NavDrawerItem.scss';

type AnchorElementProps = JSX.IntrinsicElements['a'];
type ButtonElementProps = JSX.IntrinsicElements['button'];
type ComposedProps = AnchorElementProps & ButtonElementProps;
interface NavDrawerItemProps extends ComposedProps {
  item: NavItemData;
  back?: boolean;
  onBack?: () => any;
  onActive?: (itemPath) => any;
  itemPath?: string[];
  tabIndex: number;
  tracking?: any;
}

export class NavDrawerItem extends React.PureComponent<NavDrawerItemProps> {
  handleActiveProxy = () => {
    const {onActive = NOOP, itemPath} = this.props;

    onActive(itemPath);
  };

  renderLink() {
    const {item, tabIndex} = this.props;

    return (
      <li className={styles.item}>
        <a
          className={styles.itemLink}
          href={item.url}
          itemProp="name"
          tabIndex={tabIndex}
          {...item.tracking}
        >
          <Flex justifyContent="space-between" alignItems="center" className={styles.label}>
            {item.prefix ? <Text type="small" text={item.prefix} resetMargin /> : null}
            <Text type="small" text={item.title} resetMargin ellipsis />
          </Flex>
        </a>
      </li>
    );
  }

  renderBackButton() {
    const {item, onBack = NOOP, tabIndex} = this.props;

    return (
      <div className={styles.backWrapper}>
        <button
          onClick={onBack}
          className={styles.back}
          type="button"
          tabIndex={tabIndex}
          {...item.tracking}
        >
          <Flex alignItems="center" className={styles.label}>
            <Icon
              icon="dropdown"
              size={20}
              fill="silver"
              className={classNames(styles.leftChevron, styles.icon)}
              aria-hidden
            />
            <Text text={item.title} type="small" resetMargin ellipsis />
          </Flex>
        </button>
      </div>
    );
  }

  renderButton() {
    const {item, tabIndex} = this.props;

    return (
      <li className={styles.item}>
        <button
          className={styles.itemButton}
          itemProp="name"
          type="button"
          onClick={this.handleActiveProxy}
          tabIndex={tabIndex}
          aria-haspopup
          {...item.tracking}
        >
          <Flex justifyContent="space-between" alignItems="center" className={styles.label}>
            <Text text={item.title} type="small" resetMargin ellipsis />
            <Icon
              icon="dropdown"
              size={20}
              fill="silver"
              className={classNames(styles.rightChevron, styles.icon)}
            />
          </Flex>
        </button>
      </li>
    );
  }

  render() {
    const {item, back = false} = this.props;

    if (item.children.length > 0) {
      return this.renderButton();
    }
    if (back) {
      return this.renderBackButton();
    }
    return this.renderLink();
  }
}
